<template>
  <div class="sns-post-item-parts">
    <official-post-item-parts v-if="snsPost.linkType === 'official'" :snsPost="snsPost" />
    <highlights-post-item-contents-parts
      v-else-if="snsPost.linkType === 'highlights'"
      :snsPost="snsPost"
    />
    <sns-post-item-contents-parts
      v-else
      :snsPost="snsPost"
      @updateSnsContentsData="updateSnsContentsData"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import SnsPostItemContentsParts from '@/components/HomePage/HomePane/parts/SnsPostItemContentsParts.vue'
import OfficialPostItemParts from '@/components/HomePage/HomePane/parts/OfficialPostItemContentsParts.vue'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'
import HighlightsPostItemContentsParts from '@/components/HomePage/HomePane/parts/HighlightsPostItemContentsParts.vue'

/**
 * HOME SNS投稿コンテンツ
 */
export default defineComponent({
  name: 'SnsPostItemParts',
  components: {
    HighlightsPostItemContentsParts,
    SnsPostItemContentsParts,
    OfficialPostItemParts,
  },
  props: {
    snsPost: {
      type: Object as PropType<SnsPostData>,
      required: true,
    },
  },
  methods: {
    updateSnsContentsData(src: string) {
      this.$emit('updateSnsContentsData', src)
    },
  },
})
</script>

<style lang="scss" scoped>
.sns-post-item-parts {
  display: block;
  width: 100%;
  padding: min(#{convertPXtoVW(16), 16px});
  text-align: left;
  background: $white;
}
</style>

<style lang="scss">
.sns-post-item-parts .post-item-contents-parts {
  &__text {
    @include fontSetTextMedium();

    font-family: $fontSignup;
    letter-spacing: 0.04em;
    color: $black80;

    a {
      color: $green-link;
      pointer-events: none;
    }

    i {
      margin-left: 0.2em;

      img {
        display: inline-block;
        width: min(#{convertPXtoVW(16), 16px});
        height: min(#{convertPXtoVW(16), 16px});
        vertical-align: middle;
        transform: translateY(-0.1em);
      }
    }
  }

  &__footer {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    padding-top: min(#{convertPXtoVW(4), 4px});
    width: 100%;
  }

  &__action-count {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    &__data {
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;

      svg {
        width: min(#{convertPXtoVW(18), 18px});
      }

      span {
        font-weight: 500;
        font-size: min(#{convertPXtoVW(12), 12px});
        line-height: 1.33;
        letter-spacing: 0.04em;
        color: $black20;
      }
    }
  }

  &__time {
    font-weight: 500;
    font-size: min(#{convertPXtoVW(10), 10px});
    line-height: 1.2;
    letter-spacing: 0.04em;
    color: $gray25;
  }
}
</style>
